// src/pages/ServicesPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import './ServicesPage.css';
import WorkProcessSection from '../components/services/WorkProcessSection';
import DescriptiveAccordion from '../components/services/DescriptiveAccordion';
import { descriptiveServicesData } from '../data/descriptiveServicesData';
import ValuePropositionSection from '../components/services/ValuePropositionSection';
import ServicePageTechStack from '../components/services/ServicePageTechStack';
import ServicePageCTA from '../components/services/ServicePageCTA';

function ServicesPage() {
  const siteUrl = "https://infocolab.com"; // URL de votre site
  const pageUrl = `${siteUrl}/services`;
  const pageTitle = "Nos Services Web - Développement, Design, SEO | INFO COLAB";
  const pageDescription = "Découvrez la gamme complète des services web offerts par INFO COLAB : développement sur mesure, design UX/UI, SEO, hébergement et maintenance à Lombez, Occitanie.";
  const ogImageUrl = `${siteUrl}/images/og-services.jpg`; // N'oubliez pas de créer cette image

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={ogImageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INFO COLAB" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={ogImageUrl} />
      </Helmet>

      <div className="container">
        <section className="services-page-section">
          <h1>Nos Services</h1> {/* TITRE H1 VISIBLE AJOUTÉ */}
          <p className="intro">
            Découvrez comment INFO COLAB peut vous aider à atteindre vos objectifs numériques
            grâce à notre gamme complète de services Web professionnels. Explorez nos domaines d'expertise ci-dessous.
          </p>

          <DescriptiveAccordion services={descriptiveServicesData} />
          <ServicePageTechStack />
          <ServicePageCTA />
          <WorkProcessSection />
        </section>
      </div>
    </>
  );
}

export default ServicesPage;